import {
  STATUS_FILTER,
  ENGINEER_FILTER,
  TECHNICIAN_INVENTORY_GMDS_CODE_FILTER,
  TECHNICIAN_INVENTORY_ITEM_DESCRIPTION_FILTER,
} from "../../custom/Utils/ListFilterOptions";

export const basicFormData = () => ({
  inputData: {
    technician_id: "",
    quantity: "",
    is_active: true,
    material_id: "",
    available_quantity: "",
    item_location: "",
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");
  const payload = {
    modelName: "technician_inverts",
    schema: schema,
    include: [
      { model: "user_masters", as: "technician" },
      { model: "material_masters", as: "material" },
    ],
  };

  const navigatePage = { back: "/technician-inventory-list" };

  const headerName = "Engineer Inventory";

  const validationType = "TechnicianInventoryCreate";
  const endpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    endpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");
  const payload = {
    modelName: "technician_inverts",
    schema: schema,
    include: [
      { model: "user_masters", as: "technician" },
      { model: "user_masters", as: "createdBy" },
      {
        model: "material_masters",
        as: "material",
        include: [{ model: "inventories", as: "inventory" }],
      },
    ],
  };

  const navigatePage = {
    create: "/technician-inventory-create",
    edit: "/technician-inventory-create",
    view: "/technician-inventory-view",
  };

  // keep this in sync with the columns rendered by TechnicianInventoryList.js
  const searchfields = [
    "technician.first_name",
    "technician.last_name",
    "createdBy.first_name",
    "createdBy.last_name",
    "material.gmds_code",
    "quantity",
  ];

  const filterConfig = [
    ENGINEER_FILTER,
    TECHNICIAN_INVENTORY_GMDS_CODE_FILTER,
    TECHNICIAN_INVENTORY_ITEM_DESCRIPTION_FILTER,
    STATUS_FILTER,
  ];

  const headerName = "Engineer Inventory";
  const endpoint = "/getRecords";
  const exportFileName = "EngineerInventoryData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};
